export default "supabase>=2.15.0\nhttpx>=0.27.0\nopencv-python>=4.9.0\ncertifi>=2024.8.30\n"